import { UrlSerializer, UrlTree, DefaultUrlSerializer } from '@angular/router';
import { HttpParams } from '@angular/common/http'; // Import HttpParams

export class CustomUrlSerializer implements UrlSerializer {
  private static platformPremium = false;

  parse(url: string): UrlTree {
    const defaultSerializer = new DefaultUrlSerializer();
    const tree = defaultSerializer.parse(url);
    const params = tree.queryParams;

    // Check if 'platform=premium' is present in the current URL's query params
    if (params['platform'] === 'premium') {
      CustomUrlSerializer.platformPremium = true;
    }
    return tree;
  }

  serialize(tree: UrlTree): string {
    const defaultSerializer = new DefaultUrlSerializer();
    let url = defaultSerializer.serialize(tree);

    if (CustomUrlSerializer.platformPremium) {
      const urlParts = url.split('?');
      const path = urlParts[0];
      const query = urlParts[1] || '';
      let params = new HttpParams({ fromString: query });

      // Append 'platform=premium' if not already present
      if (!params.has('platform')) {
        params = params.set('platform', 'premium');
      } else {
        // Ensure existing 'platform' is set to 'premium'
        params = params.set('platform', 'premium');
      }

      url = path + '?' + params.toString();
    }
    return url;
  }
}
